export default __webpack_public_path__ + "static/media/Su2.970f8866.png";